import { Component, OnInit } from "@angular/core";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { CommonService } from "src/app/core/services/common.service";
import { TranslateService } from "@ngx-translate/core";
import { CVEService } from "./cve.service";

@Component({
  selector: "app-cve",
  templateUrl: "./cve.component.html",
  styleUrls: ["./cve.component.scss"],
})
export class CveComponent {
  public cve: string = "";
  public numDoc: string = "";

  constructor(
    private toastrAlertService: ToastrAlertService,
    private translateService: TranslateService,
    private cveService: CVEService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService
  ) {}

  onDownload() {
    if ((!this.numDoc || this.numDoc == "") && (!this.cve || this.cve == "")) {
      let message =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        this.translateService.instant("messages.cveRequired") +
        "<br/>" +
        this.translateService.instant("messages.numDocRequired");

      this.toastrAlertService.toastrFail(message);
    } else if (!this.cve || this.cve == "") {
      let message =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        this.translateService.instant("messages.cveRequired");
      this.toastrAlertService.toastrFail(message);
    } else if (!this.numDoc || this.numDoc == "") {
      let message =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        this.translateService.instant("messages.numDocRequired");
      this.toastrAlertService.toastrFail(message);
    } else {
      this.sweetAlertService.sweetAlertLoading();
      this.cveService.downloadFile(this.cve, this.numDoc).subscribe(
        (data) => {
          this.commonService.downloadFile(
            data,
            "Certificado_" + this.numDoc + ".pdf"
          );
          this.numDoc = "";
          this.cve = "";
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastFailBlob(err.error);
          this.sweetAlertService.sweetAlertClose();
        }
      );
    }
  }
}
